module.exports = __webpack_public_path__ + "static/media/jabalí.0ba96208.png";